import { DirectConnectDC301 } from '../dc301/dc301';
import { DirectConnectGW3 } from '../gateway/gw3/gw3';
import { DirectConnectGW4 } from '../gateway/gw4/gw4';
import { DirectConnectNL4 } from '../nl4/nl4';
import { DirectConnectNR4 } from '../nr4/nr4';
import { DirectConnectRE4 } from '../re4/re4';
import { DirectConnectRR4 } from '../rr4/rr4';

let initialized = false;
export function InitDirectConnectDeviceTypes() {
  if (initialized) {
    return;
  }
  initialized = true;
  DirectConnectGW3.Init();
  DirectConnectGW4.Init();
  DirectConnectNR4.Init();
  DirectConnectRE4.Init();
  DirectConnectRR4.Init();
  DirectConnectDC301.Init();
  DirectConnectNL4.Init();
}
